import { IFrame, IFrameAccordion } from '@features/pages/typescript';
import sanitizeHtml from '@utils/sanitizeHtml';
import styles from '@features/pages/components/PagesAccordion/components/FrameAccordion.styles';
import contentStyles from '@features/pages/PagesContent.styles';
import theme from '@styles/theme';
type PropsType = {
  frame: IFrameAccordion;
  defaultBackground?: string;
  withContainerMargin?: boolean;
};
const FrameAccordion = ({
  frame,
  defaultBackground = theme.rawColors.neutralWhite,
  withContainerMargin = false
}: PropsType) => {
  const {
    frames
  } = frame;
  const CONFIG_SANITIZE = {
    allowedTags: ['h2', 'h3', 'h4', 'h5', 'h6', 'h7', 'p', 'ul', 'li', 'ol', 'a', 'b', 'strong', 'em', 'br'],
    allowedAttributes: {
      p: ['style'],
      ol: ['style'],
      ul: ['style'],
      h2: ['style'],
      h3: ['style'],
      h4: ['style'],
      h5: ['style'],
      h6: ['style'],
      h7: ['style'],
      a: ['href', 'target', 'rel']
    },
    allowedStyles: ['list-style-type']
  };
  const innerContent = (singleFrame: IFrame) => {
    const {
      content
    } = singleFrame;
    return sanitizeHtml(content, CONFIG_SANITIZE);
  };
  return <div sx={styles.container(withContainerMargin, defaultBackground)} data-testid="frame-accordion-container">
      {frames.map((singleFrame, index) => <div key={Math.random()} sx={{
      ...styles.frame(singleFrame.width),
      ...contentStyles.containerContent(singleFrame.width === 'full')
    }} data-testid={`frame-accordion-frame-${index}`} dangerouslySetInnerHTML={innerContent(singleFrame)} />)}
    </div>;
};
export default FrameAccordion;